import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SuperAdminDashboardRedirect = () => {
  const { user, loading } = useAuth();

  console.log('SuperAdminDashboardRedirect - user:', user, 'loading:', loading);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (user?.role === 'SUPER_ADMIN') {
    console.log('Redirecting to super-admin');
    return <Navigate to="/super-admin" replace />;
  } else if (user?.role === 'ADMIN') {
    console.log('Redirecting to admin');
    return <Navigate to="/admin" replace />;
  } else if (user?.role === 'MANAGER') {
    console.log('Redirecting to manager');
    return <Navigate to="/manager" replace />;
  } else if (user) {
    console.log('Redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  } else {
    console.log('Redirecting to login - no user');
    return <Navigate to="/login" replace />;
  }
};

export default SuperAdminDashboardRedirect;
